<template>
    <div style="background:url(../assets/site.jpg)" class="surface-0 flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
        <div class="grid justify-content-center p-2 lg:p-0" style="min-width:80%">
            <!-- <div class="col-12 mt-5 xl:mt-0 text-center">
                <img :src="'assets/LogoDragon.png'" alt="Sakai logo" class="mb-5" style="width:81px;">
            </div> -->
            <div class="col-12 xl:col-6" style="border-radius:56px; padding:0.3rem; background: linear-gradient(180deg, var(--primary-color), rgba(33, 150, 243, 0) 30%);">
                <div class="h-full w-full m-0 py-7 px-4" style="border-radius:53px; background: linear-gradient(180deg, var(--surface-50) 38.9%, var(--surface-0));">
                    <div class="text-center mb-5">
                        <!-- <img src="layout/images/avatar.png" alt="Image" height="50" class="mb-3"> -->
                        <div class="text-900 text-3xl font-medium mb-3">Bienvenido!</div>
                        <span class="text-600 font-medium">Inicia sesión para continuar</span>
                        <div>
                            <span class="text-400 font-medium"> {{ getVersion }}</span>
                        </div>
                    </div>
                    <div class="text-center mb-3">
                        <small class="p-error">{{lblMensageError}}</small>
                    </div>                
                    <div class="w-full md:w-10 mx-auto">
                        <div class="mb-2">
                            <label for="email1" class="block text-900 text-xl font-medium mb-2">Usuario</label>
                            <InputText id="email1" v-model.trim="objLogin.usuario" type="text" class="w-full" placeholder="" style="padding:1rem;" required autofocus :class="{'p-invalid': submitted && !objLogin.usuario}"/>
                            <small class="p-error" v-if="submitted && !objLogin.usuario">El usuario es requerido.</small>
                        </div>
                        <div class="mb-3">
                        <label for="password1" class="block text-900 font-medium text-xl mb-2">Contraseña</label>
                        <Password id="password1" :feedback="false" v-model.trim="objLogin.password" placeholder=""  class="w-full" inputClass="w-full" 
                            required 
                            autofocus
                            @keyup.enter="login"
                            :class="{'p-invalid': submitted && !objLogin.password}"
                        ></Password>
                        <small class="p-error" v-if="submitted && !objLogin.password">La contraseña es requerida.</small>
                        <!-- <div class="flex align-items-center justify-content-between mb-5">
                            <div class="flex align-items-center">
                                <Checkbox id="rememberme1" v-model="checked" :binary="true" class="mr-2"></Checkbox>
                                <label for="rememberme1">Remember me</label>
                            </div>
                            <a class="font-medium no-underline ml-2 text-right cursor-pointer" style="color: var(--primary-color)">Forgot password?</a>
                        </div> -->
                        </div>
                        <Button label="Continuar" class="w-full p-3 text-xl" @click="login"></button>
                        <div class="w-full flex justify-content-center">
                            <Button label="¿Olvidaste tu contraseña?" class="p-button-text" style="margin-top:10px" @click="resetPassword" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Admin from '../service/Admin'
import Empleados from '../service/Empleados';
import {mapActions,mapGetters} from 'vuex'
export default {
    data() {
        return {
            submitted: false,
            objLogin:{},
            lblMensageError: null
        }
    },
    computed: {
        ...mapGetters(["getVersion","getUrlFrontAdmin","getUsuarioLogueado"]),
        logoColor() {
            if (this.$appState.darkTheme) return 'white';
            return 'dark';
        },
    },
    methods:{
        ...mapActions([
            "setUsuarioLogueado"
        ]),
        login(){
            this.lblMensageError ="";
            var t = this;
            t.submitted = true;
            var svrlogin = new Admin();

            if(t.objLogin && t.objLogin.usuario && t.objLogin.password){
                var params = {
                    Usuario: t.objLogin.usuario,
                    Password: t.objLogin.password,
                    ClaveSistema: "RDSYUC"
                };
                svrlogin.login(t,params).then(res =>{                                             
                            if(res.Usuario.Id_estatus == 1){
                                if(res.Usuario_unidades!= null && res.Usuario_unidades.length>0){
                                    t.submitted = false;
                                    let serviceEmpleados = new Empleados();
                                    t.setUsuarioLogueado(res);

                                    serviceEmpleados.getEmpleado(t,res.Usuario.Matricula).then(resEmpleado => {
                                        res.Empleado_ci = resEmpleado;
                                        t.setUsuarioLogueado(res);
                                        if(res.Usuario_sistema.Id_rol == 3 || res.Usuario_sistema.Id_rol == 9 )
                                            t.$router.push("/equiposcomputo");
                                        else
                                            t.$router.push("/");
                                    })

                                }
                                else{
                                    t.$toast.add({
                                        severity:"warn",
                                        summary:"AVISO",
                                        detail:"El usuario no tiene ninguna unidad asignada",
                                        life: 3500
                                    });
                                }
                            }
                            else{
                                t.$toast.add({
                                    severity:"warn",
                                    summary:"AVISO",
                                    detail:"La cuenta de usuario no esta activa",
                                    life: 3000
                                });
                            }
                }).catch(e=>{
                    this.lblMensageError=e.error;
                });
            }
        },
        resetPassword(){
            window.location.href = this.getUrlFrontAdmin + "#/restablecer";
            // window.location.href = "http://frontadmin.cdiyucatan.mx/#/restablecer";
        },
    }
}
</script>

<style scoped>
.pi-eye {
    transform:scale(1.6);
    margin-right: 1rem;
}

.pi-eye-slash {
    transform:scale(1.6);
    margin-right: 1rem;
}
</style>